<template>
  <div style="height: 100%">
    <div
      v-if="allowed"
      style="
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      "
      @dblclick="openBookInWindow"
      @click="openBookFromBtn"
      @contextmenu="openBookTab"
    >
      <h2
        @click="toggleShiur"
        v-if="isShiur"
        style="text-align: center; margin: 5px"
      >
        {{ subjectHeader }}
      </h2>
      <div v-if="popup">
        <bookPreview
          :book="book"
          :shiurTitle="mefSectionOrdered.title"
          @close="popup = false"
          :pages="pages"
          :canvases="canvases"
          :clearStart="isShiur"
          :spaceBottom="spaceBottom"
        ></bookPreview>
      </div>
      <template v-if="!isShiur || (isShiur && shiurOpen)">
        <div v-if="fullPage || isShiur">
          <div v-for="(page, i) in pages" :key="page.pageNum">
            <hr v-if="i > 0 && i < pages.length" />
            <pageView
              :page="page"
              :clearStart="isShiur && i == 0"
              :mask="true"
              :addPadding="isRambamMef"
            >
            </pageView>
          </div>
        </div>
        <template v-else>
          <template v-for="(page, x) in pages">
            <template v-for="(column, y) in page.columns">
              <template v-for="(rects, i) in column.marks">
                <mefoSubSection
                  :rects="rects"
                  :id="rects.id"
                  :key="x + '_' + y + '_' + i + 'r' + rects.id"
                  :img="page.img"
                  :addPadding="isRambamMef"
                  @canvasCreated="addCanvas"
                ></mefoSubSection>
              </template>
            </template>
          </template>
          <div class="continue-read-btn" v-if="isRambamMef && loadFullSection">
            להמשך קריאה...
          </div>
        </template>
      </template>
    </div>
    <div v-else class="err-no-lic" @click="openNoLicBookInWindow">
      {{
        appMode.online()
          ? $t("mefo.noPageViewLicense")
          : $t("mefo.noViewLicense")
      }}
    </div>
  </div>
</template>

<script>
import bookPreview from "@/components/mefo/bookPreview.vue";
import mefoSubSection from "@/components/mefo/mefoSubSection.vue";
import pageView from "@/components/mefo/pageView.vue";
import { getImageObject } from "@/services/bookData.js";
import ImageProccessor from "@/services/ImageProccessor.js";
import winManager from "@/services/book_win";
import {
  openBook,
  rambamTiferetBooks,
  getPageDataByPos,
} from "@/services/bookData.js";
import { createFreeSearchBookListStore } from "@/store_pinia";
import { getOCR } from "@/services/bookToolBoxMethods.js";
import { getWordsCoords } from "@/services/freeSearch.js";
import { mapGetters } from "vuex";
export default {
  components: { mefoSubSection, pageView, bookPreview },
  props: [
    "mefSectionOrdered",
    "fullPage",
    "resize_trigger",
    "book",
    "loadFullSection",
    "tempBookImages",
    "allowed",
    "enterclicked",
    "currentIndex",
    "searchId",
  ],
  data() {
    return {
      pages: [],
      canvases: [],
      spaceBottom: 5,
      popup: false,
      shiurOpen: false,
      preventClose: 0,
    };
  },
  beforeDestroy() {
    Object.keys(this.pages).forEach((p) => {
      globalThis.reduceCanvasMemory(this.pages[p].img.picture);
    });
  },
  async created() {
    this.createCanvases();
  },
  computed: {
    ...mapGetters("tabsManager", ["getCurrentBook"]),
    masks() {
      return this.mefSectionOrdered.nextPagesCount ||
        (this.mefSectionOrdered.type == "z" && this.isRambamMef) //z=full page meforesh
        ? {}
        : this.mefSectionOrdered.pages;
    },
    isRambamMef() {
      try {
        return rambamTiferetBooks.includes(parseInt(this.getCurrentBook));
      } catch {
        return false;
      }
    },
    subjectHeader() {
      if (this.isRambamMef) return "חיפוש ממוקד";
      else return `${this.$t("mefo.subject")} ${this.mefSectionOrdered.title}`;
    },
    getCurrentList() {
      return createFreeSearchBookListStore(this.searchId).getCurrentList;
    },
    firstImgLoaded() {
      return this.pages.length > 0;
    },
    isShiur() {
      return this.mefSectionOrdered?.type == "s";
    },
  },
  methods: {
    toggleShiur() {
      this.shiurOpen = !this.shiurOpen;
    },
    openNoLicBookInWindow() {
      if (this.appMode.offline()) return;
      this.openBookInWindow();
    },
    openBookTab() {
      if (!this.$_mobile) return;
      const pageID = Object.entries(
        this.mefSectionOrdered.pages
      )[0][1].page.trim();
      this.$store.state.tabsManager.scrollToMefMask = true;

      this.$store.state.mobile.tab = "BOOK";
      return openBook(
        this.mefSectionOrdered.book,
        "PID_" + pageID,
        null,
        null,
        true
      );
    },
    openBookFromBtn(e) {
      if (e.target.className == "continue-read-btn") this.openBookInWindow();
    },
    openBookInWindow() {
      this.$emit("preventclose", true);
      let bookFs = undefined;
      if (this.$store.state.freeSearch.searchType === "mefo") {
        let fsBook = this.getCurrentList.booksList.find(
          (b) => b.id == this.mefSectionOrdered.book
        );
        if (fsBook) bookFs = fsBook.fs;
      }

      const pageID = Object.entries(
        this.mefSectionOrdered.pages
      )[0][1].page.trim();
      this.$store.state.tabsManager.scrollToMefMask = true;

      const page = pageID ? "PID_" + pageID : -1;
      winManager.createWinBook(
        this.mefSectionOrdered.book,
        bookFs ? -1 : page,
        null,
        undefined,
        null,
        false,
        bookFs,
        this.masks
        //columns
      );
    },
    async loadAndDrawPage(p) {
      const page = p;

      page.img = await this.loadImg(page);
      if (this.isShiur && this.isRambamMef) {
        this.getSectionOcr(page, page.page, 0, 0, 1, 1);
      }
      for (const col in page.columns) {
        const column = page.columns[col];
        for (const rects of column.marks) {
          rects.finalSizes = this.canvasFinalSizes(rects, page.img, column);
        }
      }

      this.$set(this.pages, this.pages.length, page);
    },
    async createCanvases() {
      if (!this.allowed) return;
      const firstOnly = !this.loadFullSection && !this.fullPage;
      const orgPages = Object.values(this.mefSectionOrdered.pages);
      for (let i = 0; i < orgPages.length; i++) {
        if (i > 0 && firstOnly) continue;
        const pageLoaded = this.pages.includes(orgPages[i]);
        if (!pageLoaded) await this.loadAndDrawPage(orgPages[i]);
      }
      this.$nextTick(() => {
        this.$emit("myHeight", this.$el.clientHeight);
      });
    },
    addCanvas(data) {
      //this.$set(this.canvases, data.id, data.cnv);
      this.canvases.push(data.cnv);
    },
    async loadImg(page) {
      const { angle, page: pageId, pageNum } = page.columns[0].marks[0];
      const { book } = this.mefSectionOrdered;

      //for 2 sections with the same image
      //avoid load more then 1 time
      if (this.tempBookImages && this.tempBookImages[pageId])
        return this.tempBookImages[pageId];

      try {
        //get image

        let img = await getImageObject(
          book,
          pageId.trim(),
          "image",
          false,
          {
            zoom: 100,
          },
          null,
          pageNum,
          5
        );

        //rotat
        if (angle > 180) angle = angle - 360;
        if (angle)
          img.picture = ImageProccessor.rotateCanvas(img.picture, angle);

        return img;
      } catch (ex) {
        console.log(`error getting img >> ${ex.message}`);
        return null;
      }
    },
    drawPages() {
      /** @type HTMLCanvasElement */
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      canvas.width = 100;
      canvas.height = 0;

      for (const page of this.pages) {
        canvas.width = Math.max(page.img.picture.width, canvas.width);

        const add = page.img.picture.height + this.spaceBottom;
        canvas.height += add;
        ctx.drawImage(page.img.picture, 0, canvas.height - add);

        const orgImgSize = {
          w: page.img.picture.width,
          h: page.img.picture.height,
        };

        for (const col in page.columns) {
          const column = page.columns[col];
          for (const rects of column.marks) {
            //convert to px
            const x = rects.x * orgImgSize.w;
            const y = rects.y * orgImgSize.h + (canvas.height - add);
            const h = rects.h * orgImgSize.h;
            const w = rects.w * orgImgSize.w;

            ctx.fillStyle = "rgba(0,0,0,0.05)";
            ctx.fillRect(x, y, w, h);
          }
        }
      }
    },
    getSectionOcr(page, pageId, x, y, width, height) {
      const orgImgSize = {
        w: page.img.picture.width,
        h: page.img.picture.height,
      };

      x *= orgImgSize.w;
      y *= orgImgSize.h;
      width *= orgImgSize.w;
      height *= orgImgSize.h;
      getOCR({
        bookId: this.book.id,
        pageId: pageId,
        x,
        y,
        width: 10000,
        height: 10000,
        startWord: -1,
        numWord: -1,
        pageData: {},
        positions: true,
        search: ['רמב"ס', 'רמב"ם', 'הר"מ', 'הר"ם'],
      }).then(async (ocr) => {
        if (ocr.data) {
          if (ocr.data) {
            let pageData = await getPageDataByPos(
              this.book.id,
              page.pageNum + 1
            );

            let margin = pageData ? pageData.pagedata[0]?.margin || 0 : 0;

            getWordsCoords({
              bookId: this.book.id,
              pageId: pageId,
              words: ocr.data,
              margin,
              webP: page.img.imageMetaData.PDF,
            })
              .then((result) => {
                if (result.data && result.data.length)
                  page.searchHighlights = result.data[0];
              })
              .catch((ex) => {
                console.log(ex);
              });
          }
        }
      });
    },
    canvasFinalSizes(rects, img, column) {
      const calcSizes = this.calcSizes(rects, column);
      const { canvasHeight, canvasWidth, location } = calcSizes;

      const orgImgSize = { w: img.width, h: img.height };
      //convert to px
      const x = rects.x * orgImgSize.w;
      const y = rects.y * orgImgSize.h;
      const h = rects.h * orgImgSize.h;
      const w = rects.w * orgImgSize.w;

      const distX = location * orgImgSize.w;
      const distY = 0;
      const width = canvasWidth * orgImgSize.w;
      const height = canvasHeight * orgImgSize.h;

      return { width, height, x, y, w, h, distX, distY };
    },
    calcSizes(rects, col) {
      const widestColWidth = this.mefSectionOrdered.widestColWidth;
      const leftSpaceFromCol = Math.abs(col.x - rects.x);
      let canvasHeight = rects.h;
      let canvasWidth = rects.isKoteret ? rects.w : widestColWidth;

      let location = leftSpaceFromCol + (widestColWidth - col.w);
      if (rects.manualPosition) {
        switch (rects.manualPosition) {
          case "left":
            location = 0;
            break;
          case "right":
            location = canvasWidth - rects.w;
            break;
          case "center":
            location = (canvasWidth - rects.w) / 2;
            break;
          case "original":
            location = location;
            break;
          case "fill":
            location = 0;
            break;
        }
      } else {
        location = rects.isKoteret ? 0 : location;
      }

      return {
        canvasHeight,
        canvasWidth,
        location,
      };
    },
  },
  watch: {
    enterclicked() {
      if (this.enterclicked == this.currentIndex) {
        this.openBookInWindow();
      }
    },
    canvases: function (val, oldV) {
      // this.$emit("setSecCanvass", Object.values(val));
      this.$emit("setSecCanvass", val);
    },
    fullPage: function (val, oldV) {
      this.createCanvases();
    },
    loadFullSection: function (val, oldV) {
      this.createCanvases();
    },
    loadContent: function (val, oldV) {
      if (this.loadContent) this.createCanvases();
    },
    resize_trigger: function (val, oldV) {
      this.createCanvases();
    },
  },
};
</script>

<style lang="scss" scoped>
.continue-read-btn {
  position: absolute;
  left: 5px;
  bottom: 5px;
  width: 100px;
  height: 29px;
  background-color: white;
  border: var(--custom-color2) solid 1px;
  padding: 4px;
  padding-top: 2px;
  &:hover {
    background-color: #d4d4d4;
  }
}
.err-no-lic {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: red;
}
.next-pages {
  position: absolute;
  left: 10px;
  bottom: 32px;
  border: solid 1px var(--custom-color1);
  padding: 2px;
  background-color: white;
  &:hover {
    background-color: lightgray;
  }
}
</style>
